/* eslint-disable max-lines */
import { setFacetThreshold } from 'actions/identifier';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getCompareMode, getShouldDisableEdit } from 'selectors/identifier';
import { useSelector } from 'store';

type ComponentProps = {
  category: string;
  categoryThreshold: string;
  prodCategoryThreshold: string;
};

const CategoryThresholdInput: React.FC<ComponentProps> = ({
  category,
  categoryThreshold,
  prodCategoryThreshold,
}) => {
  const dispatch = useDispatch();

  const compareMode = useSelector(getCompareMode);
  const shouldDisable = useSelector(getShouldDisableEdit);

  const [stringThreshold, setStringThreshold] = useState(categoryThreshold);

  const handleChangeStringThreshold = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;
    const numValue = Number.parseFloat(e.target.value.slice(0, value.startsWith('.') ? 3 : 4));

    if (value) {
      if (numValue >= 0 && numValue <= 1) {
        dispatch(setFacetThreshold({ facet: category, threshold: numValue }));

        if (value.startsWith('.') && value.length < 4) {
          setStringThreshold(value);
          return;
        }
        if (!value.startsWith('.') && value.length < 5) {
          setStringThreshold(value);
        }
      }
    } else {
      dispatch(setFacetThreshold({ facet: category, threshold: 0 }));
      setStringThreshold(value);
    }
  };

  return (
    <label key={category} htmlFor={category} className="flex flex-col gap-1 text-body w-50">
      <div className="flex flex-row">
        <span>{category}</span>
        <span className="text-litlingo-alert">*</span>
      </div>

      <input
        id={category}
        name={category}
        type="number"
        min={0}
        max={1}
        step={0.01}
        maxLength={3}
        className={`form-input w-full h-9 py-2 px-4 border border-litlingo-gray-2 rounded-lg text-body focus:outline-none ${
          prodCategoryThreshold !== categoryThreshold && compareMode
            ? 'bg-litlingo-focus-area-background'
            : ''
        }`}
        data-testid={`${category}-threshold-input`}
        value={stringThreshold}
        onChange={handleChangeStringThreshold}
        onBlur={(): void => {
          setStringThreshold(categoryThreshold.toString());
        }}
        disabled={compareMode || shouldDisable}
      />
    </label>
  );
};

export default CategoryThresholdInput;
